import { router } from "@inertiajs/react"
import { getCsrfToken } from "@/lib/csrf"

export function flushTenantCache() {
  // /company/* is keyed only by URL: stale prefetch would bring back the previous company.
  router.cancelAll({ prefetch: true })
  router.flushAll()
}

export function switchCompany(companyId: number) {
  flushTenantCache()
  router.patch(
    "/current_company",
    { company_id: companyId, authenticity_token: getCsrfToken() },
    {
      preserveState: false,
      onSuccess: () => router.flushAll(),
    },
  )
}

export function respondToInvitation(
  invitationId: number,
  action: "accept" | "decline",
  callbacks: { onStart?: () => void; onFinish?: () => void } = {},
) {
  if (action === "accept") flushTenantCache()
  router.post(
    `/incoming_invitations/${invitationId}/${action}`,
    {},
    {
      preserveScroll: true,
      onStart: () => callbacks.onStart?.(),
      onSuccess: () => {
        if (action === "accept") router.flushAll()
      },
      onFinish: () => callbacks.onFinish?.(),
    },
  )
}
